// extracted by mini-css-extract-plugin
module.exports = {"analyzer_button":"AnalyzerButton_analyzer_button__1mMS7"};